import { ModalHandler } from '@app-velocity/ui';

import { IncorrectFlowStructureModalContent } from './components/IncorrectFlowStructureModalContent';

export const IncorrectFlowStructureModal = () => {
  return (
    <ModalHandler channel="prototypes" id="incorrect-flow-structure">
      <IncorrectFlowStructureModalContent />
    </ModalHandler>
  );
};
